














































import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { BButton, BIconPlus, BModal } from 'bootstrap-vue';
import DataTable from '@/components/DataTable.vue';
import ClientFilter from '@/components/ClientFilter.vue';
import ClientFilterOptions from '@/types/ClientFilterOptions';
import ClientList from '@/components/ClientList.vue';
import ClientDetails from '@/components/ClientDetails.vue';

@Component({
    components: {
        'default-layout': DefaultLayout,
        'data-table': DataTable,
        'client-filter': ClientFilter,
        'client-list': ClientList,
        'b-btn': BButton,
        'b-icon-plus': BIconPlus,
        'b-modal': BModal,
        'client-details': ClientDetails
    }
})
export default class ClientsView extends Vue {
    clientId = ''
    showModal = false;
    refreshList = false;
    modalTitle = '';
    filter: ClientFilterOptions = {
        sequenceOrName: null,
        isActive: true
    };

    onClientSelected(id: string) {
        this.clientId = id;
        this.modalTitle = this.$t('modal.clientDetailsTitle') as string;
        this.showModal = true;
    }

    onLoadComplete() {
        this.refreshList = false;
    }

    onClientSaved(result: boolean) {
        this.showModal = false;

        if (result) {
            this.refreshList = true;
        }
    }

    onClientDeleted() {
        this.showModal = false;
        this.refreshList = true;
    }

    addNewClient() {
        this.clientId = '';
        this.modalTitle = this.$t('modal.newClientTitle') as string;
        this.showModal = true;
    }

    onFilterList(filter: ClientFilterOptions) {
        this.filter = filter;
        this.refreshList = true;
    }
}
